import { action, makeObservable, observable } from 'mobx';
import { type ApprovableInsightDrawable, CollectionModelDrawable, MoveableDrawable } from './drawable';
import { CollectionModelDrawableState } from './drawable.state';
import { CollectionModelDrawableLine } from './line.drawable';

export class CollectionModelDrawableLinePoint extends MoveableDrawable {
	constructor(
		collectionModelDrawableState: CollectionModelDrawableState,
		drawableId: string,
		x: number,
		y: number,
		parentId: string
	) {
		super(collectionModelDrawableState, drawableId);
		makeObservable(this);

		this.x = x;
		this.y = y;
		this._parentId = parentId;
	}

	static isLinePoint(t: CollectionModelDrawable): t is CollectionModelDrawableLinePoint {
		return t instanceof CollectionModelDrawableLinePoint;
	}

	@observable override x: number = 0;
	@observable override y: number = 0;

	/** Lines can only be moved left/right */
	@action override move(x: number, y: number) {
		const bounds = this.getPointInBounds(x, this.y);
		this.x = bounds.x;
		this.y = bounds.y;
	}

	protected _parentId: string;

	get parent(): CollectionModelDrawableLine {
		return this.drawableState.getDrawable<CollectionModelDrawableLine>(this._parentId);
	}

	override remove() {
		super.remove();
		// Remove this line-point's parent too, unless it has already been removed
		if (this.drawableState.hasDrawable(this._parentId)) {
			this.parent.remove();
		}
	}
	override get isInsightMeasurement(): boolean {
		return false;
	}

	override isApprovableInsightDrawable(): this is ApprovableInsightDrawable {
		return false;
	}

	override get isVisible(): boolean {
		return true;
	}

	override clone(newParentDrawableState: CollectionModelDrawableState): CollectionModelDrawableLinePoint {
		return new CollectionModelDrawableLinePoint(newParentDrawableState, this.id, this.x, this.y, this._parentId);
	}

	override equals(other: CollectionModelDrawable): boolean {
		return (
			other instanceof CollectionModelDrawableLinePoint &&
			this._parentId === other._parentId &&
			this.x === other.x &&
			this.y === other.y &&
			this._equals(other)
		);
	}
}
